export enum ReminderTargetType {
  User = 'User',
  Customer = 'Customer',
  Vendor = 'Vendor',
  Lead = 'Lead',
  Quote = 'Quote',
  Project = 'Project',
  Task = 'Task',
  Invoice = 'Invoice',
  // Other = 'Other',
}
